export * from "./lyrics";
